import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useMemo } from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
var safelyDecodeURIComponent = function safelyDecodeURIComponent(value) {
  var decodedValue;
  if (value && value.replace) {
    value = value.replace(/\+/g, ' ');
  }
  try {
    decodedValue = decodeURIComponent(value);
  } catch (error) {
    decodedValue = value;
  }
  return decodedValue;
};
var queryStringToParams = function queryStringToParams(queryString) {
  var response = {};
  var decodedQS = decodeURI(queryString).split('&');
  decodedQS.forEach(function (param) {
    var _param$split = param.split('='),
      _param$split2 = _slicedToArray(_param$split, 2),
      paramKey = _param$split2[0],
      paramValue = _param$split2[1];
    try {
      response[paramKey] = JSON.parse(paramValue);
    } catch (e) {
      response[paramKey] = safelyDecodeURIComponent(paramValue);
    }
  });
  return response;
};
export var withRouter = function withRouter(Component) {
  function ComponentWithRouterProp(props) {
    var location = useLocation();
    var navigate = useNavigate();
    var rrParams = useParams();
    var router = useMemo(function () {
      var locationObj = Object.assign(Object.assign({}, location), {
        query: location.search ? queryStringToParams(location.search.substring(1)) : {},
        search: location.search || ''
      });
      var history = {
        push: function push() {
          return navigate.apply(void 0, arguments);
        },
        replace: function replace(params) {
          return navigate(params, {
            replace: true
          });
        },
        goBack: function goBack() {
          return navigate(-1);
        },
        go: function go(idx) {
          return navigate(idx);
        },
        location: locationObj
      };
      return Object.assign(Object.assign({}, history), {
        location: Object.assign(Object.assign({}, location), {
          query: location.search ? queryStringToParams(location.search.substring(1)) : {},
          search: location.search || ''
        }),
        params: rrParams,
        getCurrentLocation: function getCurrentLocation() {
          return location;
        }
      });
    }, [location, navigate, rrParams]);
    return /*#__PURE__*/React.createElement(Component, Object.assign({}, props, {
      params: router.params,
      location: router.location,
      router: router
    }));
  }
  return ComponentWithRouterProp;
};